import { endpoints } from "serverDetails";
import api, {
  ApiResponse,
  ApiReturnDto,
  isSuccessResponse,
  UNKNOWN_ERROR,
} from "api";
import { AvailableImageTypeResponse, DownloadImagesPayload } from "./models";

export class DownloadFarmImagesApi {
  public static getImageOptions = async (): Promise<
    ApiReturnDto<AvailableImageTypeResponse>
  > => {
    try {
      const result = await api.get<ApiResponse<AvailableImageTypeResponse>>(
        endpoints.reportsModule.getImageTypes
      );
      if (isSuccessResponse(result.data)) {
        return {
          data: result.data.details,
          errors: null,
        };
      }
      return {
        data: null,
        errors: [UNKNOWN_ERROR],
      };
    } catch (error) {
      console.warn("Error in getImageOptions", error);
      return {
        data: null,
        errors: [UNKNOWN_ERROR],
      };
    }
  };
  public static downloadImages = async (
    payload: DownloadImagesPayload
  ): Promise<ApiReturnDto<unknown>> => {
    try {
      const result = await api.get<ApiResponse<unknown>>(
        endpoints.reportsModule.downloadImages,
        {
          params: payload,
        }
      );
      if (isSuccessResponse(result.data)) {
        return { data: result.data.details, errors: null };
      }
      return {
        data: null,
        errors: result.data.errors ?? [UNKNOWN_ERROR],
      };
    } catch (error) {
      console.warn("Error in downloadImages", error);
      return {
        data: null,
        errors: [UNKNOWN_ERROR],
      };
    }
  };
}
